export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q03_b.21e87e95.png";